import { Link as ReactRouterLink, LinkProps as ReactRouterLinkProps } from 'react-router-dom';
import { ReactNode } from 'react';

type CustomLinkProps = Omit<ReactRouterLinkProps, 'to'> & {
	to?: string;
	href?: string;
	children?: ReactNode;
	className?: string;
	role?: string;
};

/**
 * Link component - React Router version
 * Replaces Next.js Link with React Router Link
 */
function Link(props: CustomLinkProps) {
	const { to, href, children, className, role, ...rest } = props;
	const targetUrl = to || href || '/';

	return (
		<ReactRouterLink
			to={targetUrl}
			className={className}
			role={role}
			{...rest}
		>
			{children}
		</ReactRouterLink>
	);
}

export default Link;
